<template>
  <div>
    <h2><span
      v-if="ball.innings != 'superover'">Inn {{ball.innings}}</span><span
      v-else>Super Over</span>,
      {{ball.over-1}}.{{ball.ball}} ov
    </h2>
    <div class="dl-box">
      <div class="silent" v-html="ball.comment"></div>
      <br/>
    </div>

    <div class="dl-box dd-55">
      <dl v-if="match.players">
        <dt>Striker:</dt>
        <dd v-if="match.players[ball.striker] && match.players[ball.striker].name">{{match.players[ball.striker].name}}</dd><dd v-else>-</dd>
        <dt>Bowler:</dt>
        <dd v-if="match.players[ball.bowler.key] && match.players[ball.bowler.key].name">{{match.players[ball.bowler.key].name}}</dd><dd v-else>-</dd>
        <dt>Non Striker:</dt>
        <dd v-if="match.players[ball.nonstriker] && match.players[ball.nonstriker].name">{{match.players[ball.nonstriker].name}}</dd><dd v-else>-</dd>
      </dl>
    </div>

    <div class="dl-box dd-55" v-if="ball.wicket_type">
      <div class="name">Wicket</div>
      <dl>
        <dt>Dismissed:</dt>
        <dd v-if="match.players[ball.wicket] && match.players[ball.wicket].name">{{match.players[ball.wicket].name}}</dd><dd v-else>-</dd>
        <dt>Wicket Type:</dt>
        <dd>{{ball.wicket_type | capitalise}}</dd>
        <template v-if="ball.fielder && ball.fielder.key">
          <dt v-if="ball.wicket_type == 'runout'">Hitter:</dt>
          <dt v-else-if="ball.wicket_type == 'stumbed'">Stumbed:</dt>
          <dt v-else-if="ball.wicket_type == 'catch'">Caught:</dt>
          <dt v-else>Fielder:</dt>
          <dd v-if="match.players[ball.fielder.key] && match.players[ball.fielder.key].name">{{match.players[ball.fielder.key].name}}</dd><dd v-else>-</dd>
        </template>
        <template v-if="ball.other_fielder">
          <dt v-if="ball.wicket_type == 'runout'">Thrower:</dt>
          <dt v-else>2nd Fielder:</dt>
          <dd v-if="match.players[ball.other_fielder] && match.players[ball.other_fielder].name">{{match.players[ball.other_fielder].name}}</dd><dd v-else>-</dd>
        </template>
        <dt>Decision By:</dt>
        <dd>{{ball.decision_by | capitalise}}</dd>
      </dl>
    </div>

    <div class="dl-box dd-55">
      <div class="name">{{ball.ball_type | capitalise}} ball</div>
      <dl>
        <dt>Runs:</dt>
        <dd>{{ball.runs}}<span v-if="ball.extras != '0'">({{ball.extras}} e)</span></dd>
        <template v-if="ball.wagon_position">
          <dt>Position:</dt>
          <dd>{{ball.wagon_position}}</dd>
        </template>

        <dt>Player Runs:</dt>
        <dd v-if="ball.batsman && ball.batsman.runs">{{ball.batsman.runs}}<span
         v-if="ball.batsman.four != 0">({{ball.batsman.four}} 4s)</span><span
         v-if="ball.batsman.six != 0">({{ball.batsman.six}} 6s)</span></dd><dd v-else>-</dd>

        <dt>Team Runs:</dt>
        <dd v-if="ball.team && ball.team.runs">{{ball.team.runs}}<span v-if="ball.team.extras != 0">({{ball.team.extras}} e)</span></dd><dd v-else>-</dd>
      </dl>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      statsGroups: ['batting', 'bowling', 'fielding'],
      ignores: {
        'batting': ['dismissed', 'dismissed_at', 'out_str', 'ball_of_dismissed']
      }
    }
  },
  props: {
    match: Object,
    ball: Object
  },
  methods: {

    batString (inn) {
      const bat = this.player.match.innings[inn].batting
      return `${bat.runs}(${bat.balls}) ${bat.fours}x4s ${bat.sixes}x6s`
    },

    bowlString (inn) {
      const bowl = this.player.match.innings[inn].bowling
      return `${bowl.wickets}/${bowl.overs} (${bowl.economy} ecom)`
    },

    dismissedAtString (inn) {
      const dismissed = this.player.match.innings[inn].batting.dismissed_at
      return `${dismissed.team_runs}/${dismissed.wicket_index} (${dismissed.over}.${dismissed.ball} ov)`
    },

    statsKeys (inn, key) {
      let keys = Object.keys(this.player.match.innings[inn][key])
      const ignoreProbs = (this.ignores[key]) ? this.ignores[key] : []
      keys = keys.filter(x => ignoreProbs.indexOf(x) == -1)
      return keys
    },

    shouldShowStats (inn, key) {
      let keys = this.statsKeys(inn, key)
      return keys.length > 1
    },

    played (inn) {
      if (this.match.status.isNotStarted) {
        return false
      }

      if (!this.player.match.innings[inn]) {
        return false
      }

      for (let i = 0; i < this.statsGroups.length; i++) {
        if (this.shouldShowStats(inn, this.statsGroups[i])) {
          return true
        }
      }
      return false
    }
  }
}
</script>
